import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OPS_TRIGGERS } from 'pages/Operations/Shared/opsControlMocks'
import { IOpsTriggerRow } from 'types/operationsControl.interface'
import { IOperationTriggersSlice } from 'types/operationTriggers.interface'

const initialState: IOperationTriggersSlice = {
  triggers: OPS_TRIGGERS,
}

const operationTriggersSlice = createSlice({
  name: 'operationTriggers',
  initialState,
  reducers: {
    addTrigger: (state, action: PayloadAction<Omit<IOpsTriggerRow, 'id' | 'fireCount' | 'lastFired'>>) => {
      const nextId = state.triggers.reduce((max, t) => Math.max(max, t.id), 0) + 1
      state.triggers = [{ ...action.payload, id: nextId, fireCount: 0, lastFired: null }, ...state.triggers]
    },
    toggleTrigger: (state, action: PayloadAction<number>) => {
      state.triggers = state.triggers.map((t) =>
        t.id === action.payload ? { ...t, enabled: !t.enabled } : t,
      )
    },
    deleteTrigger: (state, action: PayloadAction<number>) => {
      state.triggers = state.triggers.filter((t) => t.id !== action.payload)
    },
  },
})

export const { addTrigger, toggleTrigger, deleteTrigger } = operationTriggersSlice.actions
export default operationTriggersSlice.reducer
